export const toTitleCase = (text = '') => {
  return text.split(/[ -]/)
    .map(word => { return word.length ? (word.length > 1 ? (word[0].toUpperCase() + word.substr(1).toLowerCase()) : word.toUpperCase()) : ' ' }).join(' ');
}


export const capitalize = (text = '') => {
  return text.split(/[ ]/)
    .map(word => { return word.length ? (word.length > 1 ? (word[0].toUpperCase() + word.substr(1).toLowerCase()) : word.toUpperCase()) : ' ' }).join(' ');
}